// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__38sXg","boxTitle":"Qualiphy_boxTitle__1iOWc","box":"Qualiphy_box__lQD5H","toggleWrap":"Qualiphy_toggleWrap__19RRe"};